import React from 'react';
import validator from 'validator';

export const required = (value) => value !== undefined && value !== null && String(value).trim() !== '';

export const email = (value) => value === undefined || value === null || validator.isEmail(String(value));

export const number = (value) => value === 0 || !isNaN(value);

export const maxLength = (value, maxLen) => String(value).trim().length <= maxLen;

export const minLength = (value, minLen) => String(value).trim().length >= minLen;

export const compare = (value, compareValue) => value === compareValue;

export const distinct = (value, compareValue) => value !== '' && value !== compareValue;

export const maxProspects = (value, maxProspectsValue) => value <= maxProspectsValue;

export const minEndDate = (date, minEndDateValue) => date >= minEndDateValue;

export const maxSum = (sum, maxSumValue) => sum <= maxSumValue;

export const minValue = (value, min) => value === undefined || value === null || value === '' || parseFloat(value) >= min;

export const maxValue = (value, max) => value === undefined || value === null || value === '' || parseFloat(value) <= max;

export const password = (value, props, components) => value === components['confirm'][0].value ? undefined : <span className="error">Passwords are not equal.</span>;

export const uniqueIdentifier = (value) => !!(value && String(value).trim().length && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value));

// export const isvalidPassword = (value) => !!(value && String(value).trim().length && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/.test(value));
export const isvalidPassword = (value) => !!(value && String(value).trim().length && /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/.test(value));

export const isValidEIN = (value) => {
    const unmaskedValue = value.replace(/\D/g, '')
    const isValid = /^\d{9}$/.test(unmaskedValue);
    return isValid;
};

export const isValidPhone = (value) => {
    const unmaskedValue = value.replace(/\D/g, '')
    const isValid = /^\d{10,15}$/.test(unmaskedValue);
    return isValid;
}

export const isValidFax = (value) => {
    const unmaskedValue = value.replace(/\D/g, '')
    const isValid = /^\d{10}$/.test(unmaskedValue);
    return isValid;
}

export const sqlQuery = (value) => {
    if (value !== undefined && value !== null && value.toString().trim().length) {
      // Check if * exists in the query
      if (value.includes('*')) {
        return false; // * is not allowed
      }
  
      // Check if the query starts with select
      if (!value.trim().toLowerCase().startsWith('select')) {
        return false; // Query must begin with select
      }
  
      // Check if the query contains disallowed keywords
      const disallowedKeywords = ['HashedPassword', 'PasswordSalt', 'IsUsedActivationLink', 'Password' ,'Query'];
      for (const keyword of disallowedKeywords) {
        if (new RegExp(`\\b${keyword}\\b`, 'i').test(value)) {
          return false; // Disallowed keyword found
        }
      }
  
      // If all checks pass, return true
      return true;
    }
    return false; // Empty or undefined value
  };


  export const validateFile = (file, acceptedFormats, minSizeMB = 0, maxSizeMB = Infinity) => {
    const validationState = {
        isValid: true,
        errorMessage: ``
    }

    if (!file) {
        // Return consistent object structure
        validationState.isValid = false;
        validationState.errorMessage = "No file selected.";
        return validationState;
    }

    // Check file format
    const fileExtension = getFileExtension(file.name);
    if (acceptedFormats?.includes('*') || acceptedFormats?.includes(fileExtension)) {
        // If "ANY" is included or the file extension is valid, set isValid to true
        validationState.isValid = true;
    } else {
        // Otherwise, mark it as invalid and show an error message
        validationState.isValid = false;
        validationState.errorMessage = `Unsupported file format. Please upload files in the allowed formats only: ${acceptedFormats.join(', ')}.`;
    }

    // Check file size
    const fileSizeMB = file.size / 1024 / 1024; // Convert bytes to MB

    if (fileSizeMB > maxSizeMB) {

        validationState.isValid = false;
        validationState.errorMessage = `File size exceeds the maximum limit of ${maxSizeMB} MB.`;
    }
    if (fileSizeMB < minSizeMB) {

        validationState.isValid = false;
        validationState.errorMessage = `File size must be at least ${minSizeMB} MB.`;
    }

    return validationState; // File is valid
};
// Get the file extension
const getFileExtension = (fileName) => {
  return fileName?.slice(fileName.lastIndexOf('.')).toLowerCase(); // Extracts the extension with the dot
};

export const validateImageFile = (file, fieldSettings, imageData) => {

  const {
      acceptedImageFormats,
      maxImageHeight,
      maxImageWidth,
      minImageHeight,
      minImageWidth,
      maxImageSizeInMB,
      minImageSizeInMB,
  } = fieldSettings;

  const validationState = {
      isValid: true,
      errorMessage: ``
  }

  if (!file) {
      validationState.isValid = false;
      validationState.errorMessage = "No file selected.";
      return validationState;
  }

  // Check file format
  const fileExtension = getFileExtension(file.name);
  if (acceptedImageFormats?.includes('*') || acceptedImageFormats.some(acceptable => acceptable === fileExtension)) {
      validationState.isValid = true;
  } else {
      validationState.isValid = false;
      validationState.errorMessage = `Unsupported file format. Please upload files in the allowed formats only: ${acceptedImageFormats.join(', ')}.`;
      return validationState;
  }

  // Check file size
  const fileSizeMB = file.size / 1024 / 1024; // Convert bytes to MB
  if (fileSizeMB > maxImageSizeInMB) {
      validationState.isValid = false;
      validationState.errorMessage = `File size exceeds the maximum limit of ${maxImageSizeInMB} MB.`;
      return validationState;
  }

  if (fileSizeMB < minImageSizeInMB) {
      validationState.isValid = false;
      validationState.errorMessage = `File size must be at least ${minImageSizeInMB} MB.`;
      return validationState;
  }

  const { height, width } = imageData;

  if (width > maxImageWidth || height > maxImageHeight) {

      validationState.isValid = false;
      validationState.errorMessage = `Image dimensions exceed the maximum limit of ${maxImageWidth}x${maxImageHeight} pixels.`;

  } else if (width < minImageWidth || height < minImageHeight) {

      validationState.isValid = false;
      validationState.errorMessage = `Image dimensions must be at least ${minImageWidth}x${minImageHeight} pixels.`;

  }
  return validationState;
}